module.exports = __webpack_public_path__ + "static/crowd-b6f4762a16f0f9b98e117848fe687dea.jpg";